export default __webpack_public_path__ + "static/media/client-26.8657a10d.webp";